import React from 'react';
import Hero from '../components/home/Hero';
import TrustMetrics from '../components/home/TrustMetrics';
import Features from '../components/home/Features';
import Industries from '../components/home/Industries';
import Testimonials from '../components/home/Testimonials';
import CallToAction from '../components/home/CallToAction';
import SEO from '../components/common/SEO';

const HomePage = () => {
  return (
    <>
      <SEO 
        titleKey="hero.title"
        descriptionKey="footer.description"
        keywords="B2B, e-commerce, food industry, wholesale, platform"
      />
      
      <Hero />
      <TrustMetrics />
      <Features />
      <Industries />
      <Testimonials />
      <CallToAction />
    </>
  );
};

export default HomePage; 